<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Forgot Password</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form @submit.prevent="onForgot()">
                            <v-text-field
                                    placeholder="Your registered MPE account email address"
                                    v-validate="'required|email'"
                                    prepend-icon="person"
                                    v-model="email"
                                    :error-messages="errors.collect('email')"
                                    label="E-mail"
                                    data-vv-name="email"
                                    required
                            >
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :to="{ name: 'home'}" outline color="error">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="(isSubmitting || errors.any() )" color="primary" @click="onSubmit()">Forgot</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'Forgot',
  components: {
  },
  data () {
    return {
      isSubmitting: false,
      email: process.env.VUE_APP_LOGIN_EMAIL
    }
  },
  computed: {
  },
  methods: {
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isSubmitting = true
          this.onForgot()
        } else {
          this.$snotify.error(this.$validator.errors.all())
        }
      })
    },
    onForgot () {
      this.axios.post('auth/forgot', { email: this.email })
        .then(response => {
          this.$snotify.success(response.data.data.success)
          this.email = null
          this.$validator.reset()
          this.errors.clear()
          this.$router.push({ name: 'home' })
        })
        .catch(error => {
          this.$snotify.error(error.response.data.data.error)
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped>

</style>
